import { type BackOfficeFeatures, type PermissionsDTO, type PermissionsResponse } from '@bluebrick/electron-api-module/main'
import type { User, UserDTO } from '@/features/api/types'
import { useApi } from '@/features/api/useAPI'
import { useNotificationsStore } from '@/features/notifications/useNotificationsStore'
import { useTelemetry } from '@/features/telemetry/useTelemetry'

export async function get(): Promise<User | undefined> {
	const { notifyError } = useNotificationsStore()
	const { trackException } = useTelemetry()
	const { apiGet } = useApi()

	try {
		const { data } = await apiGet<UserDTO>('/user')

		return { ...data, readonly: Boolean(data.parent) }
	} catch (e) {
		trackException(e as Error, 'Failed to load user data.')

		notifyError('Failed to load user data.')
	}
}

export async function fetchUserFeatures(): Promise<BackOfficeFeatures[] | undefined> {
	const { notifyError } = useNotificationsStore()
	const { trackException } = useTelemetry()
	const { apiGet } = useApi()

	try {
		const { data } = await apiGet<{ features: BackOfficeFeatures[] }>('/features')

		return data.features
	} catch (e) {
		trackException(e as Error, 'Failed to load user features.')

		notifyError('Failed to load user features.')
	}
}

export async function fetchUserPermissions(): Promise<PermissionsDTO | undefined> {
	const { notifyError } = useNotificationsStore()
	const { trackException } = useTelemetry()
	const { apiGet } = useApi()

	try {
		const { data } = await apiGet<PermissionsResponse>('/user/permissions')

		return data.permissions
	} catch (e) {
		trackException(e as Error, 'Failed to load user permissions.')

		notifyError('Failed to load user permissions.')
	}
}
